module.exports = __webpack_public_path__ + "static/media/lx-xt.c3713f3e.jpg";